import React from 'react';
import { Button } from './Button';
import { ShieldCheck, Heart, Sparkles } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-37">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-38">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-sage-light/20 blur-3xl" data-id="element-39" />
        <div className="absolute top-[40%] -left-[10%] w-[40%] h-[40%] rounded-full bg-terracotta-light/10 blur-3xl" data-id="element-40" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-41">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-42">
          {/* Left Column: Copy */}
          <div className="max-w-2xl" data-id="element-43">
            <div className="inline-flex items-center space-x-2 px-3 py-1 rounded-full bg-sage-light/30 text-sage-dark text-sm font-medium mb-6" data-id="element-44">
              <Sparkles className="w-4 h-4" data-id="element-45" />
              <span data-id="element-46">Para perros y gatos</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-gray-900 leading-tight mb-6" data-id="element-47">
              Duplica los años de vida de tu{' '}
              <span className="text-sage-dark italic" data-id="element-48">mejor amigo</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-49">
              El Método Maestro de Bio-Nutrición y Convivencia. Descubre los
              secretos científicamente probados para una vida más larga, sana y
              feliz junto a tu mascota.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-50">
              <Button size="lg" withArrow data-id="element-51">
                Obtener la Biblia Ahora
              </Button>
            </div>

            <div className="flex items-center space-x-6 text-sm text-gray-500" data-id="element-52">
              <div className="flex items-center" data-id="element-53">
                <ShieldCheck className="w-5 h-5 text-sage mr-2" data-id="element-54" />
                <span data-id="element-55">Garantía 30 días</span>
              </div>
              <div className="flex items-center" data-id="element-56">
                <Heart className="w-5 h-5 text-terracotta mr-2" data-id="element-57" />
                <span data-id="element-58">Acceso Inmediato</span>
              </div>
            </div>
          </div>

          {/* Right Column: 3D Mockup */}
          <div className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-59">
            <div className="relative aspect-[4/5] w-full" data-id="element-60">
              {/* Image Frame */}
              <div className="absolute inset-0 rounded-3xl shadow-2xl transform rotate-3 transition-transform hover:rotate-0 duration-500 overflow-hidden border-8 border-white/20" data-id="element-61">
                <img src="https://cdn.magicpatterns.com/uploads/fWBENmkb8J95c3teTYM9Sr/imagen_3.png" alt="Perro y gato descansando juntos" className="w-full h-full object-cover" data-id="element-62" />
              </div>

              {/* Decorative floating elements */}
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-terracotta rounded-2xl shadow-lg transform -rotate-12 flex items-center justify-center p-4" data-id="element-63">
                <span className="text-white font-bold text-center text-sm leading-tight" data-id="element-64">
                  100%
                  <br data-id="element-65" />
                  Digital
                </span>
              </div>
              <div className="absolute -top-6 -right-6 w-20 h-20 bg-cream-dark rounded-full shadow-lg flex items-center justify-center" data-id="element-66">
                <Sparkles className="w-8 h-8 text-sage-dark" data-id="element-67" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}